import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input } from 'semantic-ui-react';
import DatePicker, { registerLocale } from "react-datepicker";
import fi from "date-fns/locale/fi";
import { ButtonContainer, CancelBtn, SaveBtn } from 'Components/Buttons';
import useCreateAnnouncement from './useCreateAnnouncement';
//import typeOptions from './typeOptions';
import '../UpdateAnnouncement/announcements.css';

/** New announcement form is used to create new portal announcement */
const CreateAnnouncement: React.FC = () => {

    const { t } = useTranslation();
    registerLocale("fi", fi);
    const navigate = useNavigate();
    const createAnnouncement = useCreateAnnouncement();

    const [ isLoading, setIsLoading ] = useState(false);
    const [ title, setTitle ] = useState("");
    const [ description, setDescription ] = useState("");
    const [ startDate, setStartDate ] = useState(new Date());
    const [ endDate, setEndDate ] = useState(new Date());
    //const [ type, setType ] = useState("info");

    const onSubmit = async () => {

        setIsLoading(true);

        const newAnnouncement = {
            "title": title,
            "description": description,
            "startDate": startDate,
            "endDate": endDate,
            //"type": type
        };

        let result = await createAnnouncement(newAnnouncement);

        if (result && result.status === 201) return navigate(-1);

        setIsLoading(false);      

    }

    return (
        <div className="portal-announcement">
            <Form loading={isLoading} onSubmit={onSubmit} >

                {/* Title */}
                <Form.Field
                    required
                    control={Input}
                    label={t('features.announcements.title')}
                    value={title || ''}
                    onChange={(ev: Event, {value}: any) => setTitle(value)}
                />

                {/* Start date */}
                <div className="calendar">
                    <Form.Field required>
                        <label>{t('features.announcements.startDate')}</label>
                    </Form.Field>
                    <DatePicker
                        id="startDate"
                        required
                        selected={startDate}
                        onChange={(date: Date) => setStartDate(date)}
                        locale='fi'
                        inline
                    />
                </div>
                
                {/* End date */}
                <div className="calendar">
                    <Form.Field required>
                        <label>{t('features.announcements.endDate')}</label>
                    </Form.Field>
                    <DatePicker
                        id="endDate"
                        required
                        selected={endDate}
                        onChange={(date: Date) => setEndDate(date)}
                        locale='fi'
                        inline
                    />
                </div>

                {/* Description */}
                <Form.Field
                    control={Input}
                    label={t('features.announcements.description')}
                    value={description || ''}
                    onChange={(ev: Event, {value}: any) => setDescription(value)}
                />

                {/* Message Type 
                <Form.Field required>
                    <label>{t('features.announcements.type')}</label>
                </Form.Field>
                <Dropdown
                    required
                    fluid
                    selection
                    options={typeOptions}
                    onChange={(ev: React.SyntheticEvent<HTMLElement, Event>, {value}: any) => setType(value)}
                    value={type}
                />
                <br/>*/}

                <ButtonContainer>
                    <SaveBtn  />
                    <CancelBtn />
                </ButtonContainer>

            </Form>
        </div>
    );

}

export default CreateAnnouncement;
